export default "__VITE_ASSET__CGxLpO7H__"